import React from 'react';
import moment from 'moment';
import { lifecycleDateFormat } from './createDatesUtils';

interface ILifecycleDatesRow {
  label: string;
  days: number | string;
  startDate?: moment.Moment;
  endDate?: moment.Moment;
  className?: string;
}

function LifecycleDatesRow({ label, days, startDate, endDate, className }: ILifecycleDatesRow) {
  return (
    <div className={`grid-x small-12 px-create-date-filter-selector-container ${className ?? ''}`}>
      <div className="cell small-2 create-dates-labels">
        {label} ({days}D):
      </div>
      <div className="margin-left-2">
        {startDate ? startDate.format(lifecycleDateFormat) : '--'} &nbsp; &nbsp; to &nbsp; &nbsp;
        {endDate ? endDate.format(lifecycleDateFormat) : '--'}
      </div>
    </div>
  );
}

export default LifecycleDatesRow;
